import { Map } from 'lucide-react';

const SectionDivider = () => {
  return (
    <section className="container mx-auto px-4 pt-8 pb-4 relative z-10">
      <div className="flex items-center justify-center gap-4">
        <div className="w-8 h-0.5 bg-gradient-to-r from-transparent to-blue-300 animate-pulse"></div>
        <Map className="h-6 w-6 text-blue-500 animate-pulse" />
        <div className="w-8 h-0.5 bg-gradient-to-l from-transparent to-blue-300 animate-pulse"></div>
      </div>
    </section>
  );
};

export default SectionDivider; 